var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 6.25C11.6484 6.25 12 6.60156 12 7V10C12 10.4219 11.6484 10.75 11.25 10.75H0.75C0.328125 10.75 0 10.4219 0 10V7C0 6.60156 0.328125 6.25 0.75 6.25H11.25ZM8.25 9.0625C8.55469 9.0625 8.8125 8.82812 8.8125 8.5C8.8125 8.19531 8.55469 7.9375 8.25 7.9375C7.92188 7.9375 7.6875 8.19531 7.6875 8.5C7.6875 8.82812 7.92188 9.0625 8.25 9.0625ZM9.75 9.0625C10.0547 9.0625 10.3125 8.82812 10.3125 8.5C10.3125 8.19531 10.0547 7.9375 9.75 7.9375C9.42188 7.9375 9.1875 8.19531 9.1875 8.5C9.1875 8.82812 9.42188 9.0625 9.75 9.0625ZM11.25 0.25C11.6484 0.25 12 0.601562 12 1V4C12 4.42188 11.6484 4.75 11.25 4.75H0.75C0.328125 4.75 0 4.42188 0 4V1C0 0.601562 0.328125 0.25 0.75 0.25H11.25ZM8.25 3.0625C8.55469 3.0625 8.8125 2.82812 8.8125 2.5C8.8125 2.19531 8.55469 1.9375 8.25 1.9375C7.92188 1.9375 7.6875 2.19531 7.6875 2.5C7.6875 2.82812 7.92188 3.0625 8.25 3.0625ZM9.75 3.0625C10.0547 3.0625 10.3125 2.82812 10.3125 2.5C10.3125 2.19531 10.0547 1.9375 9.75 1.9375C9.42188 1.9375 9.1875 2.19531 9.1875 2.5C9.1875 2.82812 9.42188 3.0625 9.75 3.0625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServer);
export default __webpack_public_path__ + "static/media/IconServer.ee2dab633640562889e41f11fc02eb95.svg";
export { ForwardRef as ReactComponent };